import CryptoJS from "crypto-js";

export default {
  //加密
  encrypt(word) {
    var key = CryptoJS.enc.Utf8.parse(GlobalVariable.RequestParaSecrectKey);
    var iv = GlobalVariable.RequestParaSecrectIV;
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: CryptoJS.enc.Utf8.parse(iv), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, blockSize: 128 });
    return encrypted.toString();
  },
  //解密
  decrypt(word) {
    var key = CryptoJS.enc.Utf8.parse(GlobalVariable.RequestParaSecrectKey);
    var iv = GlobalVariable.RequestParaSecrectIV;
    var decrypt = CryptoJS.AES.decrypt(word, key, { iv: CryptoJS.enc.Utf8.parse(iv), mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, blockSize: 128 });
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }
}



// WEBPACK FOOTER //
// ./src/libs/AES.js